<template>
  <v-dialog
    :value="value"
    max-width="500px"
    @input="val => $emit('dialogToggle', val)"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('editItem') }}</span>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <time-picker
                v-model="editedItem.start_time"
                :label="$t('startTime')"/>
            </v-flex>
            <v-flex xs12>
              <time-picker
                v-model="editedItem.end_time"
                :label="$t('endTime')"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          flat
          @click="close"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          @click="save"
        >
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TimePicker from '@/components/global-components/inputs/TimePicker'

export default {
  name: 'DialogTimesheetEditorDay',
  components: { TimePicker },
  props: [
    'value',
    'editedItem',
    'breakTime'
  ],
  methods: {
    save () {
      this.$emit('save', this.editedItem)
    },
    close () {
      this.$emit('close')
    }
  },
  i18n: {
    messages: {
      de: {
        save: 'Speichern',
        cancel: 'Abbrechen',
        startTime: 'Angefangen um...',
        endTime: 'Aufgehört um...',
        editItem: 'Eintrag editieren'
      },
      en: {
        save: 'Save',
        cancel: 'Abbrechen',
        startTime: 'Started at...',
        endTime: 'Stopped at...',
        editItem: 'Edit entry'
      },
      ru: {
        save: 'Сохранить',
        cancel: 'Отмена',
        selectedMonth: 'День',
        startTime: 'Начал в...',
        endTime: 'Закончил в...',
        editItem: 'Изменить запись'
      }
    }
  }
}
</script>

<style scoped>

</style>
